import { AnusayaFresh, Heritage, IndiaCup, TennisCricket, WNF } from "..";

const testimonialData = [
  {
    name: "Santosh Nanekar",
    project: "TennisCricket.in",
    description: `"Working with Brand Craft is super smooth. They always meet deadlines and communicate well. Great team to work with!"`,
    clientLogo: TennisCricket,
  },
  {
    name: "Bonnie Dsouza",
    project: "WHY NOT FITNESS",
    description: `"Love how Brand Craft brings our fitness brand to life. 
Clean designs, great video ideas, and perfect timing.
Feels like they’re part of our team."`,
    clientLogo: WNF,
  },
  {
    name: "Dinesh Shinde",
    project: " Anusaya Fresh",
    description: `"Very happy with the results from Brand Craft.
Customers love our content.
We trust them completely!"`,
    clientLogo: AnusayaFresh,
  },
  {
    name: "Vijay Agarwal",
    project: "India Cup",
    description: `"Brand Craft has been a solid partner for India Cup. They helped us scale India Cup’s presence online. Appreciate their efforts!"`,
    clientLogo: IndiaCup,
  },
  {
    name: "Sai Vara Prasad",
    project: "Heritage",
    description: `"Professional and reliable team. Highly recommend Brand Craft!"`,
    clientLogo: Heritage,
  },
];

export default testimonialData;
